
import Vue from 'vue';
import Component from 'vue-class-component';

@Component
export default class AlertBanner extends Vue {
  showBanner = false;
  // get showBanner() {}
}
